import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  container: {
    boxShadow: "0 1px 1px rgba(0, 0, 0, 0.1) !important",
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("md")]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  },
  audienceDetailsLeft: {
    width: "70%",
    display: "flex",
    flexDirection: "column",
    gap: 5,
    paddingRight: theme.spacing(5),
  },
  audienceName: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 8,
  },
  name: {
    display: "inline-block",
    verticalAlign: "bottom",
    maxWidth: 300,
  },
  audienceMeta: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 2,
  },
  audienceDetailsRight: {
    width: "30%",
    display: "flex",
    gap: 5,
    justifyContent: "space-between",
    alignItems: "center",
  },
  audienceCustomers: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
}));
